"use client";

import { QueryParameters as BrandPageQueryParameters } from "@faire/web-api/routes/brand/brandToken";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { History } from "history";

import { useLoggedOutProductFilters } from "@faire/retailer/components/LoggedOutBrand/brand-products/useLoggedOutProductFilters";

export const useBrandPageQueryParams = (
  locationPush: (location: History.LocationDescriptor) => void
) => {
  const queryParams = useQueryParams(BrandPageQueryParameters.parse);
  const { refP } = queryParams;
  const { selectedCategoryFilterKey, setCategoryFilterKey } =
    useLoggedOutProductFilters(locationPush);

  return {
    selectedCategoryFilterKey,
    setCategoryFilterKey,
    refP,
  };
};
